var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmaterialUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13.001,
    viewBox: "0 0 13 13.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-update",
    "data-name": "Icon material-update",
    d: "M17.5,9.643H12.6l1.979-2.037a5.084,5.084,0,0,0-7.136-.072,4.966,4.966,0,0,0,0,7.071,5.07,5.07,0,0,0,7.136,0,4.7,4.7,0,0,0,1.473-3.532H17.5A6.747,6.747,0,0,1,15.6,15.616a6.539,6.539,0,0,1-9.187,0A6.385,6.385,0,0,1,6.393,6.53a6.491,6.491,0,0,1,9.137,0L17.5,4.5ZM11.363,8.111v3.07l2.528,1.5-.52.874-3.091-1.835V8.111Z",
    transform: "translate(-4.502 -4.5)",
    fill: "#7a7a7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialUpdate);
export default __webpack_public_path__ + "static/media/Icon material-update.820af9b7.svg";
export { ForwardRef as ReactComponent };